<template>
  <button
    :class="variant"
    :data-backdrop="dataBackdrop"
    :data-target="dataTarget"
    :data-toggle="dataToggle"
    :style="{ 'min-width': minWidth }"
    :type="type"
    @click.self="click"
  >
    <i v-if="i" class="pr-2" :class="i + ' ' + classIcon" @click.self="click" />

    <slot>{{ text }}</slot>
    <i v-if="iright" class="pl-2" :class="iright" />
  </button>
</template>

<script>
export default {
  // i: Icono del button a izquierda.
  // iright: Icono del button a derecha.
  // variant: Clase css.
  //Para modal: dataTarget = data-target
  //Para modal: dataToggle = data-toggle
  //Para modal: dataBackdrop = data-backdrop
  name: 'ActionButton',
  meta: {
    description: 'Componente común de acciones personalizadas para botones',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    variant: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para definir estilos',
        example: 'outline-danger',
      },
    },
    type: {
      type: String,
      default: 'button',
      meta: {
        description: 'Especifica la naturaleza del componente',
        example: 'button',
      },
    },
    text: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el texto',
        example: 'Texto requerido',
      },
    },
    classIcon: {
      type: String,
      default: '',
      meta: {
        description: 'Estilos para el icono',
        example: 'Texto requerido',
      },
    },
    i: {
      type: String,
      default: '',
      meta: {
        description: 'Icono del botón a la izquierda.',
        example: 'Texto requerido',
      },
    },
    iright: {
      type: String,
      default: '',
      meta: {
        description: 'Icono del botón a la derecha',
        example: 'Texto requerido',
      },
    },
    dataTarget: {
      type: String,
      default: '',
      meta: {
        description: 'Apunta a la identificación del modal',
        example: 'Texto requerido',
      },
    },
    dataToggle: {
      type: String,
      default: '',
      meta: {
        description: 'Abre la ventana modal',
        example: 'Texto requerido',
      },
    },
    dataBackdrop: {
      type: String,
      default: '',
      meta: {
        description:
          'Especifica si el modal debe tener una superposición oscura',
        example: 'Texto requerido',
      },
    },
    minWidth: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped>
button {
  color: #3f5b60;
  background-color: #ffffff;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  border-radius: 4px;
  height: 2.375rem;
  border: 1px solid #3f5b60;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
}

.success {
  color: #ffffff;
  background-color: #2db782;
  border-color: #2db782;
}

.outline-success {
  color: #2db782;
  background-color: #ffffff;
  border-color: #2db782;
  outline: none;
}

.outline-success:hover {
  color: #fff;
  background-color: #2db782;
}

.danger {
  color: #ffffff;
  background-color: #c9545e;
  border-color: #c9545e;
}

.outline-danger,
.outline-danger:active {
  color: #c9545e;
  background-color: #ffffff;
  border-color: #c9545e;
  outline: none !important;
}

.outline-danger:hover {
  background-color: #c9545e;
  color: #ffffff;
}

.warning {
  color: #ffffff;
  background-color: #ffc107;
  border-color: #ffc107;
}

.outline-warning {
  color: #ffc107;
  background-color: #ffffff;
  border-color: #ffc107;
}

.dark {
  color: #ffffff;
  background-color: #3f5b60;
  border-color: #3f5b60;
}

.outline-dark {
  color: #3f5b60;
  background-color: #ffffff;
  border-color: #3f5b60;
}
.outline-muted {
  color: #e2e2e2;
  background-color: #ffffff;
  border-color: #e2e2e2;
}
.outline-orange {
  color: #ff7058;
  background-color: #ffffff;
  border-color: #ff7058;
}
.outline-orange:focus {
  outline: unset;
}

.success:link,
.success:visited,
.success:hover,
.success:active {
  color: #fff;
  text-decoration: none;
  background-color: #2b9d71;
  border: 1px solid #2b9d71;
}
.success.focus,
.success:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
.success:disabled {
  color: #ffffff;
  background-color: rgb(170, 170, 170);
  border-color: rgb(170, 170, 170);
  cursor: default;
}
.danger {
  font: Bold 16px/23px Lato;
}
/* This property get to be used when the component is using an icon without text and does not need a right space or left space */
.no-padding {
  padding-right: 0px !important;
}

.orange {
  background-color: #ff7058;
  color: #ffffff;
  border-color: #ff7058;
}

.orange:focus {
  outline: none;
}

.transparent {
  color: #3f5b60;
  background-color: #f4f6f3;
  border-color: #f4f6f3;
}

.transparent:focus {
  outline: none;
}
</style>
